var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 505.709 505.709",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.554 71.862c-99.206-95.816-256.486-95.816-355.692 0-98.222 101.697-95.405 263.762 6.292 361.984 99.206 95.816 256.486 95.816 355.692 0 98.222-101.696 95.405-263.762-6.292-361.984zm-5.74 349.952-.085-.085c-93.352 93.267-244.636 93.198-337.903-.154S-9.372 176.94 83.98 83.673s244.636-93.198 337.903.153a238.932 238.932 0 0 1 69.905 169.028 238.934 238.934 0 0 1-69.974 168.96z",
    fill: "#a09e9e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.641 325.729-47.957-47.787c-10.884-10.91-28.552-10.931-39.462-.047l-.047.047-27.477 27.477a6.058 6.058 0 0 1-7.765.683 310.599 310.599 0 0 1-42.069-35.328 312.33 312.33 0 0 1-31.915-37.291 5.973 5.973 0 0 1 .597-7.765l28.16-28.16c10.872-10.893 10.872-28.531 0-39.424l-47.957-47.957c-11.051-10.565-28.458-10.565-39.509 0l-15.189 15.189c-22.939 22.681-31.128 56.359-21.163 87.04a255.982 255.982 0 0 0 31.232 63.317 323.712 323.712 0 0 0 40.96 49.835 321.547 321.547 0 0 0 54.869 44.288 244.287 244.287 0 0 0 70.997 31.573 82.193 82.193 0 0 0 19.797 2.389 86.357 86.357 0 0 0 60.843-25.6l13.056-13.056c10.871-10.892 10.871-28.53-.001-39.423zm-12.084 27.785-.034.034.085-.256-13.056 13.056a68.267 68.267 0 0 1-64.427 18.432 226.834 226.834 0 0 1-65.877-29.525 304.371 304.371 0 0 1-51.968-41.899 306.71 306.71 0 0 1-38.827-47.104 238.907 238.907 0 0 1-29.184-59.051 68.265 68.265 0 0 1 17.067-69.717l15.189-15.189c4.223-4.242 11.085-4.257 15.326-.034l.034.034 47.957 47.957c4.242 4.223 4.257 11.085.034 15.326l-.034.034-28.16 28.16c-8.08 7.992-9.096 20.692-2.389 29.867A329.334 329.334 0 0 0 220 282.978a327.314 327.314 0 0 0 44.373 37.291c9.167 6.394 21.595 5.316 29.525-2.56l27.221-27.648c4.223-4.242 11.085-4.257 15.326-.034l.034.034 48.043 48.128c4.243 4.222 4.258 11.083.035 15.325z",
    fill: "#a09e9e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.8064460d1bf844dbf102847f03b15469.svg";
export { ForwardRef as ReactComponent };